export const GameVideo = () => {
  return (
    <>
    

          <iframe width="560" height="315" src="https://www.youtube.com/embed/YRZtSKVT19A?si=Qacl97icKKdTTtif" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </>
  );
};
